import { Link } from 'react-router-dom';
import { faMessage, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MessgaeFrom = ({ layout }: { layout?: 'simple' | 'card' | 'split' }) => {
  return (
    <div>
      <div className="text-center">
        <h3 className="text-body-highlight">
          <h3 className="fw-bold text-uppercase mb-3">
            <span className="text-primary">Check your email</span>
          </h3>
        </h3>
        <div className="border-y"></div>

        <p className="fs-9 text-muted mb-2 mt-3 ">
          If the email belongs to a registered user, we will send instructions
          about how to reset the password.
        </p>
        <div className="email-icon">
          <FontAwesomeIcon icon={faMessage} className="text-body fs-3 form-icon" />
        </div>

        <div className="mt-3">
          <small className="text-secondary">
            Didn't receive an email?
            <Link to="/forgot-password" className="link-primary ms-1">
              Click to resend the mail
            </Link>
          </small>
        </div>
        <div className="text-end mt-3">
          <small className="text-secondary" style={{ fontSize: '1rem' }}>
            <Link to="/sign-in" className="link-primary ms-1">
              back to login
            </Link>
          </small>
        </div>
      </div>
    </div>
  );
};

export default MessgaeFrom;
